import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/Card';

export default function GoogleAdsTest() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://api.glowytics.com/api/google-ads/accounts/test', {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to fetch accounts');  
        }

        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.error);
        }

        setData(result);
      } catch (error) {
        console.error('Error:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, []); 

  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-600">Error: {error}</div>;

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold mb-6">Google Ads API Test</h1>
      
      <Card className="p-6">
        <h2 className="text-xl font-medium mb-4">Account Statistics</h2>
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="p-4 bg-green-50 rounded-lg">
            <p className="text-sm text-green-600">Active Accounts</p>
            <p className="text-2xl font-bold text-green-700">{data.stats.activeCount}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Inactive Accounts</p>
            <p className="text-2xl font-bold text-gray-700">{data.stats.inactiveCount}</p>
          </div>
        </div>

        <h2 className="text-xl font-medium mb-4">Active Accounts</h2>
        <div className="space-y-4">
          {data.accounts.map(account => (
            <div key={account.id} className="p-4 bg-gray-50 rounded-lg">
              <div className="grid gap-2">
                <div>
                  <span className="font-medium">Account ID: </span>
                  <span>{account.id}</span>
                </div>
                <div>
                  <span className="font-medium">Name: </span>
                  <span>{account.name}</span>
                </div>
                <div>
                  <span className="font-medium">Status: </span>
                  <span className="text-green-600">{account.status}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
} 